import { Color } from 'lib/Chip';
import { FrameOccupancyStatus, FrameStatusChip, UseBookedCampaignsResult } from './useBookedCampaigns.types';

export const FULL_SOT = 1;

export const SOT_EPSILON = 1e-6;

export const FRAME_STATUS_CHIPS: Record<FrameOccupancyStatus | 'allocated', FrameStatusChip> = {
  booked: { label: 'Booked', color: Color.PINK_RED },
  notAllocated: { label: 'Not allocated', color: Color.GREY },
  allocated: { label: 'Allocated', color: Color.GREEN },
};

export const EMPTY_OCCUPANCY: UseBookedCampaignsResult = {
  bookedCampaigns: {},
  occupancyStatuses: {},
};
